// extracted by mini-css-extract-plugin
module.exports = {"icons":"menu-bar_icons__1k6Hu","inActiveDelBtn":"menu-bar_inActiveDelBtn__1sfu1","searchInput":"menu-bar_searchInput__2_JqY"};